import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    questionsViewNew: {
      component: 'EditInputs',
      prev: 'questions',
      btnText: 'Создать вопрос',
      componentClass: 'pt40',
      componentData: {
        send: 'questions/QUESTION_NEW',
        inputs: [
          {
            component: 'InputText',
            name: 'name',
            label: 'Вопрос',
            rules: {
              required: true
            }
          },
          {
            component: 'InputTextarea',
            name: 'info',
            label: 'Вспомогательная информация',
            rules: {
              required: true
            }
          }
        ]
      }
    },
    questionsViewDelete: {
      component: 'EditText',
      prev: 'questions',
      btnText: 'Удалить вопрос',
      componentData: {
        send: 'questions/QUESTION_DELETE',
        text: 'Вы действительно хотите удалить этот вопрос из карты?'
      }
    },
    questionsViewDisable: {
      component: 'EditText',
      prev: 'questions',
      btnText: 'Отключить вопрос',
      componentData: {
        data: 'questions/QUESTION',
        send: 'questions/QUESTION_EDIT',
        text: 'Вы действительно хотите отключить этот вопрос в карте?',
        disable: true
      }
    },
    questionsViewEdit: {
      component: 'EditInputs',
      prev: 'questions',
      btnText: 'Сохранить изменения',
      componentClass: 'pt40',
      componentData: {
        data: 'questions/QUESTION',
        send: 'questions/QUESTION_EDIT',
        inputs: [
          {
            component: 'InputText',
            name: 'name',
            label: 'Вопрос',
            rules: {
              required: true
            }
          },
          {
            component: 'InputTextarea',
            name: 'info',
            label: 'Вспомогательная информация',
            rules: {
              required: true
            }
          }
        ]
      }
    }
  },
  actions: {
    'QUESTIONS': async () => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}questions`)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'QUESTION': async (context, params) => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}questions/${params.id}`)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'QUESTION_NEW': async (context, params) => {
      return await Vue.http.post(`${process.env.VUE_APP_API_URL}questions`, params)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'QUESTION_DELETE': async (context, params) => {
      return await Vue.http.delete(`${process.env.VUE_APP_API_URL}questions/${params.id}`,)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'QUESTION_EDIT': async (context, params) => {
      params.idquest = params.id;
      delete params.id;
      return await Vue.http.put(`${process.env.VUE_APP_API_URL}questions`, params)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    }
  }
}